/**
 * RODAPÉ
 * 
 * Dados da empresa: Dive Master Mergulho
 */

import { memo } from "react";
import { DIVE_MASTER_LOGO } from "@/config/constants";

export const FooterSection = memo(() => {
  return (
    <footer className="bg-[#001a4d] py-8 border-t border-white/10">
      <div className="max-w-4xl mx-auto px-4">
        
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          
          {/* Logo e nome */}
          <div className="flex items-center gap-3">
            <img 
              src={DIVE_MASTER_LOGO} 
              alt="Dive Master" 
              className="w-12 h-12 rounded-full"
              loading="lazy"
            />
            <div>
              <p className="text-white font-bold">Dive Master Mergulho</p>
              <p className="text-white/50 text-xs">CNPJ: 50.990.553/0001-07</p>
            </div>
          </div>
          
          {/* Endereço */}
          <div className="text-center md:text-right">
            <p className="text-white/70 text-sm">
              Rua José Alexandre Rocha, 63
            </p>
            <p className="text-white/70 text-sm">
              Porto Belo - SC
            </p>
          </div>
          
        </div>
        
        {/* Links */}
        <div className="flex flex-wrap justify-center gap-6 mt-6 pt-6 border-t border-white/10">
          <a 
            href="/politica" 
            className="text-white/50 text-xs hover:text-white transition-colors"
          >
            Política de Privacidade
          </a>
          <a 
            href="https://wa.me/5547997920909" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/50 text-xs hover:text-white transition-colors"
          >
            Contato: (47) 9.9792-0909
          </a>
          <a 
            href="https://instagram.com/mergulhobc" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/50 text-xs hover:text-white transition-colors"
          >
            @mergulhobc
          </a>
        </div>
        
        <p className="text-center text-white/30 text-xs mt-6">
          © {new Date().getFullYear()} Dive Master Mergulho. Todos os direitos reservados.
        </p>
        
      </div>
    </footer>
  );
});

export default FooterSection;
